import { createSlice } from '@reduxjs/toolkit';
import { FilterTestStatus } from '../../../Data/Search';

const defaultFilter = {
  onlyRecentTests: true,
  testStatus: FilterTestStatus.allStatuses,
  testMethods: null,
};

const { reducer, actions: sliceActions } = createSlice({
  name: 'searchWorksheets',
  initialState: {
    searchId: null,
    search: null,
    searching: false,
    worksheets: null,
    recentWorksheets: null,
    recentSearching: false,
    advancedSearchId: null,
    advancedSearch: null,
    advancedSearching: false,
    advancedWorksheets: null,
    filter: defaultFilter,
    worksheetTypes: null,
  },
  reducers: {
    searchClear: (state) => {
      state.search = null;
      state.worksheets = null;
      state.searchId = null;
      state.searching = false;
    },
    searchGet: (state, { payload: { search, searchId } = {} }) => {
      state.searchId = searchId;
      state.search = search;
      state.searching = true;
    },
    searchGetResolve: (state, { payload: { worksheets, searchId } = {} }) => {
      if (searchId === state.searchId) state.worksheets = worksheets;
      if (searchId === state.searchId) state.searching = false;
    },
    searchGetReject: (state, { payload: { searchId } = {} }) => {
      if (searchId === state.searchId) state.searching = false;
    },
    recentGet: (state) => {
      state.recentSearching = true;
    },
    recentGetResolve: (state, { payload: { recentWorksheets } = {} }) => {
      state.recentWorksheets = recentWorksheets;
      state.recentSearching = false;
    },
    recentGetReject: (state) => {
      state.recentSearching = false;
    },
    advancedSearchSetSearch: (state, { payload: { search } = {} }) => {
      state.advancedSearch = search;
    },

    advancedSearchNewSearch: (state, { payload: { search } = {} }) => {
      state.filter = defaultFilter;
      state.advancedSearch = search;
      state.advancedWorksheets = null;
      state.advancedSearchId = null;
      state.advancedSearching = false;
    },
    advancedSearchGet: (state, { payload: { searchId } = {} }) => {
      state.advancedSearchId = searchId;
      state.advancedSearching = true;
    },
    advancedSearchGetResolve: (state, { payload: { advancedWorksheets, searchId } = {} }) => {
      if (searchId === state.advancedSearchId) state.advancedWorksheets = advancedWorksheets;
      if (searchId === state.advancedSearchId) state.advancedSearching = false;
    },
    advancedSearchGetReject: (state, { payload: { searchId } = {} }) => {
      if (searchId === state.advancedSearchId) state.advancedSearching = false;
    },
    filterSet: (state, { payload: { filter } = {} }) => {
      state.filter = filter;
    },
  },
});

export { reducer };
export const actions = { ...sliceActions };
